import countries from 'i18n-iso-countries';
import { LabelList } from 'recharts';

import ICON_JPN from '@/assets/book/icon_JPN.png';
import ICON_CHN from '@/assets/book/icon_CHN.png';
import ICON_TWN from '@/assets/book/icon_TWN.png';
import ICON_USA from '@/assets/book/icon_USA.png';
import ICON_CAN from '@/assets/book/icon_CAN.png';
import ICON_SGP from '@/assets/book/icon_SGP.png';
import ICON_AUS from '@/assets/book/icon_AUS.png';
import ICON_MYS from '@/assets/book/icon_MYS.png';
import ICON_THA from '@/assets/book/icon_THA.png';
import ICON_KOR from '@/assets/book/icon_KOR.png';
import { BOOK_STATUS } from '@/types/book';

export const DATE_CATEGORY: {
  id: 'DAILY' | 'WEEKLY' | 'MONTHLY';
  value: 'DAILY' | 'WEEKLY' | 'MONTHLY';
  label: string;
}[] = [
  {
    id: 'DAILY',
    value: 'DAILY',
    label: '일별',
  },
  {
    id: 'WEEKLY',
    value: 'WEEKLY',
    label: '주별',
  },
  {
    id: 'MONTHLY',
    value: 'MONTHLY',
    label: '월별',
  },
];

export const nationCodeToName = (code: string) => {
  countries.registerLocale(require('i18n-iso-countries/langs/ko.json'));

  if (code === 'TWN') {
    return {
      code,
      name: '대만',
    };
  }

  const countryNameInKorean = countries.getName(code, 'ko');

  return {
    code,
    name: countryNameInKorean,
  };
};

export const getImageOfNation = (nation: string) => {
  if (nation === 'JPN') return ICON_JPN;
  if (nation === 'CHN') return ICON_CHN;
  if (nation === 'TWN') return ICON_TWN;
  if (nation === 'USA') return ICON_USA;
  if (nation === 'CAN') return ICON_CAN;
  if (nation === 'SGP') return ICON_SGP;
  if (nation === 'AUS') return ICON_AUS;
  if (nation === 'MYS') return ICON_MYS;
  if (nation === 'THA') return ICON_THA;
  if (nation === 'KOR') return ICON_KOR;
  return null;
};

export const VISITOR_HEADER = [
  {
    type: 'submitDate',
    label: '신청 일시',
  },
  {
    type: 'nation',
    label: '국적',
  },
  {
    type: 'gender',
    label: '성별',
  },
  {
    type: 'birth',
    label: '출생년도',
  },
  {
    type: 'visitorName',
    label: '이름',
  },
  {
    type: 'VisitorCount',
    label: '인원',
  },
  {
    type: 'bookDate',
    label: '예약 일시',
  },
  {
    type: 'bookStatus',
    label: '예약 상태',
  },
];

export const NATION_COLOR_LIST = ['#24C8FF', '#74CE30', '#FF8ED0', '#AF54FF'];

export const BOOK_COUNT_LIST = [
  {
    title: '최근 3개월 외국인 예약 접수',
    key: 'reservationCount',
  },
  {
    title: '최근 3개월 외국인 예약 확정',
    key: 'reservationConfirm',
  },
  {
    title: '최근 3개월 외국인 내원 완료',
    key: 'visitConfirm',
  },
];

export const BOOK_LIST_FILTER: {
  key: string;
  value: BOOK_STATUS;
  label: string;
}[] = [
  {
    key: 'total',
    value: '',
    label: '전체',
  },
  {
    key: 'reservationCount',
    value: 'RESERVED',
    label: '예약 접수',
  },
  {
    key: 'reservationConfirm',
    value: 'CONFIRMED',
    label: '예약 확정',
  },
  {
    key: 'visitConfirm',
    value: 'COMPLETED',
    label: '방문 완료',
  },
];

export const MONTHLY_BAR_LIST = [
  {
    dataKey: 'etc',
    fill: '#AF54FF',
  },
  {
    dataKey: 'third',
    fill: '#FF8ED0',
  },
  {
    dataKey: 'second',
    fill: '#A3F068',
  },
  {
    dataKey: 'first',
    fill: '#6FD8FC',
    radius: [2, 2, 0, 0],
    children: (
      <LabelList
        dataKey='total'
        position='top'
        color='#80848A'
        fontSize={14}
        pointerEvents='none'
        stroke='transparent'
      />
    ),
  },
];

export const MONTHLY_AREA_LIST = [
  {
    dataKey: 'area1',
    fill: '#ECFAFF',
  },
  {
    dataKey: 'area2',
    fill: '#ECFFEF',
  },
  {
    dataKey: 'area3',
    fill: '#FFECF7',
  },
  {
    dataKey: 'area4',
    fill: '#F7ECFF',
  },
];

export const WEEKLY_AREA_LIST = [
  {
    dataKey: 'area1',
    fill: '#ECFAFF',
  },
  {
    dataKey: 'area2',
    fill: '#ECFFEF',
  },
  {
    dataKey: 'area3',
    fill: '#FFECF7',
  },
  {
    dataKey: 'area4',
    fill: '#F7ECFF',
  },
];

export const WEEKLY_BAR_LIST = [
  {
    dataKey: 'etc',
    fill: '#AF54FF',
  },
  {
    dataKey: 'third',
    fill: '#FF8ED0',
  },
  {
    dataKey: 'second',
    fill: '#A3F068',
  },
  {
    dataKey: 'first',
    fill: '#6FD8FC',
    radius: [2, 2, 0, 0],
    children: (
      <LabelList
        dataKey='total'
        position='top'
        color='#80848A'
        fontSize={14}
        pointerEvents='none'
        stroke='transparent'
      />
    ),
  },
];
